import { render, staticRenderFns } from "./DeleteRoomModal.vue?vue&type=template&id=abd6573c&scoped=true&"
import script from "./DeleteRoomModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRoomModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRoomModal.vue?vue&type=style&index=0&id=abd6573c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd6573c",
  null
  
)

export default component.exports